import React from "react";
import T from "prop-types";
import moment from "moment";
import { translateProps } from "MODULES/shared/decorators";
import NOTIFICATION_TYPES from "MODULES/Notifications/notificationTypes";
import classNames from "classnames";
import { withRouter } from "react-router";
import { markRead } from "MODULES/Notifications/actions";
import { connect } from "react-redux";
import { get, isEmpty } from "lodash";
import { USER_ID } from "MODULES/users/constants";
import MarkRead from "./MarkRead";

export function Row({
  notification,
  history,
  markNotificationRead,
  filtersSet
}) {
  const { icon, iconUrl, url, message } = NOTIFICATION_TYPES[
    notification.notifier_type
  ][notification.notification_type];

  const { read } = notification;
  const classes = classNames("pull-left", { "text-bold": !read });

  return (
    <tr
      style={{
        backgroundColor: read
          ? "rgba(255, 255, 255, 0.02)"
          : "rgba(255, 255, 255, 0.1)"
      }}
      onClick={() => {
        markNotificationRead(notification.id);
        history.push(url(notification));
      }}
    >
      <td>
        {iconUrl ? (
          <img
            src={iconUrl}
            height="17px"
            className={read ? "text-muted" : ""}
            alt={notification.notifier_type}
          />
        ) : (
          <i className={`fa fa-fw ${read ? "text-muted" : ""} ${icon}`} />
        )}
      </td>
      <td>
        <div className={classes}>{message(notification)}</div>
      </td>
      <td width="25%">
        <em className="small text-muted">
          {moment(notification.created_at).calendar({
            lastWeek: "dddd [at] h:mm a"
          })}
        </em>
      </td>
      <td>
        {isEmpty(get(filtersSet, USER_ID)) && (
          <MarkRead noteId={notification.id} />
        )}
      </td>
    </tr>
  );
}

Row.propTypes = {
  history: T.shape({}),
  notification: T.shape({}).isRequired,
  markNotificationRead: T.func.isRequired
};

/* I started using this pattern a while back to make it easier
 * to render rows in our data tables. It makes the Row component
 * cleaner but it adds indirection. I'd like to revisit this problem
 * to see if we can do something more clear and intentional. ~sslotsky
 */

const withProps = translateProps(
  (s, filtersSet) => ({
    notification: s,
    key: s.id,
    filtersSet
  }),
  {
    erase: true
  }
);

export default withProps(
  connect(undefined, dispatch => ({
    markNotificationRead: noteId => dispatch(markRead(noteId))
  }))(withRouter(Row))
);



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/Row.jsx